













import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIWizardObjectDecoratable, IWizardInputDecoratable } from "../../../../../../domain/format";
import { FatalIndicator, QuotedBadge } from "./common";
import { NumberInputtableContentMixin } from "./mixins";

@Component({
  components: {
    FatalIndicator,
    QuotedBadge,
  }
})
export default class WizardContentNumberInput extends Mixins(NumberInputtableContentMixin) {
  get prefix(): string {
    return this.readDecoration(s => s.prefix);
  }

  get postfix(): string {
    return this.readDecoration(s => s.postfix);
  }

  private readDecoration(read: (s: IWizardInputDecoratable) => string): string {
    return (instanceOfIWizardObjectDecoratable(this.content) && !!read(this.content.decoration))
      ? read(this.content.decoration)
      : "";
  }
}
